import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import UIHelper from 'helpers/UIHelper';
import { useApi } from 'hooks/useApi';
import CustomerLogsApi from 'libs/api/cv/customerLogs';
import CustomerLogsAdapter from './customerLogs.adapter';

export const useCustomerLogs = (isMainPage = false) => {
  const { t } = useTranslation();

  const api = new CustomerLogsApi();

  const {
    loading,
    data,
    onChangeTableFilter,
  } = useApi({
    resourceKey: 'customer_logs',
    singleResourceKey: 'customer_log',
    api,
    isMainPage,
    adapter: CustomerLogsAdapter,
  });

  const columns = useMemo(() => {
    return [
      {
        title: t('Azione'),
        dataIndex: 'user_action',
        sorter: () => {},
      },
      {
        title: t('IP'),
        dataIndex: 'ip_short',
        sorter: () => {},
      },
      {
        title: t('IP md5'),
        dataIndex: 'ip_md5',
        sorter: () => {},
      },
      {
        title: t('Nome'),
        dataIndex: 'user.name',
        sorter: () => {},
      },
      {
        title: t('Cognome'),
        dataIndex: 'user.surname',
        sorter: () => {},
      },
      {
        title: t('Sesso'),
        dataIndex: 'user.sex_short',
        sorter: () => {},
      },
      {
        title: t('Indirizzo'),
        dataIndex: 'user.address',
        sorter: () => {},
      },
      {
        title: t('Città'),
        dataIndex: 'user.city',
        sorter: () => {},
      },
      {
        title: t('Date'),
        dataIndex: 'created_at',
        sorter: () => {},
        render: data => UIHelper.formatedDate(data),
      },
    ];
  }, [t]);

  const filters = useMemo(() => {
    return [
      {
        title: t('Email'),
        type: 'input',
        name: 'by_email',
        values: [],
      },
      {
        title: t('IP'),
        type: 'input',
        name: 'by_ip',
        values: [],
      },
      {
        title: t('Nome'),
        type: 'input',
        name: 'by_name',
        values: [],
      },
      {
        title: t('Cognome'),
        type: 'input',
        name: 'by_surname',
        values: [],
      },
      {
        title: t('Phone'),
        type: 'input',
        name: 'by_phone',
        values: [],
      },
    ];
  }, [t]);

  return {
    columns,
    data,
    filters,
    loading,
    onChangeTableFilter,
  };
};
